var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message"},[_c('center-title',{attrs:{"title":"消息详情","bottom":"0"}}),_c('div',{staticClass:"parse",domProps:{"innerHTML":_vm._s(_vm.detail.content)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }